<template>
  <div class="mainSection">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'TemplateView',
}
</script>
